<template>
    <v-app>
        <router-view></router-view>
        <v-snackbar v-model="notice.model" :color="notice.color" :timeout="notice.timeout" :right="true" :top="true">
            {{ notice.msg }}
        </v-snackbar>
    </v-app>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "App",
    data: () => ({}),
    created() {},
    computed: {
        ...mapState({
            notice: state => state.blog.notice
        })
    },
    methods: {},
    mounted() {}
};
</script>

<style>
@import "./vueblog.css";
</style>
